<template lang="pug">

    div
      div( v-if="$apollo.loading" ) Loading, please wait...
      div( v-else-if="companyMany" )
        p( v-if="label" class="mb-1" ) {{ label }}
        p( v-else class="mb-1" ) Select a company to assign:
        select( v-on:input="onInput" v-model="companyId" class="form-control" v-bind:disabled="disabled" )
          option( v-bind:value="null" ) Please select
          option( v-for="company in companyMany" v-bind:value="company.id" ) {{ company.name }}

</template>

<style lang="scss" scoped>
</style>

<script>
import Vue from 'vue'
import gql from 'graphql-tag'
export default Vue.extend({

  props: [ 'label', 'disabled' ],
    
  data() {
    return{
      companyId: '',
    }
  },

  apollo: {
    companyMany: {
      query: gql`
        query CompanyMany {
          companyMany(limit: 100000, sort: { name: ASC }) {
            name
            id
          }
      }
      `,
      fetchPolicy: 'no-cache',
    }
  },

  methods: {

    onInput(e) {
      this.$emit('input', e.target.value)
      this.$emit('input-full-object', this.companyMany.find(c => c.id === e.target.value))
    },

  },
    
})
</script>